import React from 'react';
import getStores from '../api/getStores';
import { Store } from '../types/Store';

const useStores = (): [Store[] | null, (location: string) => void, React.Dispatch<React.SetStateAction<Store[] | null>>] => {
  const [stores, setStores] = React.useState<Store[] | null>(null);
  const searchStores = React.useCallback((location: string) => {
    getStores({ location })
      .then((res) =>
        setStores(
          res.success
            ? res.payload.map((s) => ({
                ...s,
              }))
            : null,
        ),
      )
      .catch(() => setStores(null));
  }, []);

  return [stores, searchStores, setStores];
};

export default useStores;
